import React from 'react';

import Icon from '../ui-components/Icon';

interface Props {
    header: string;
    text: string;
}

const FlowAlert = ({ header, text }: Props) => {
    return (
        <div className="bg-main flex items-center justify-center rounded-md text-white">
            <div className="flex size-7 items-center justify-center rounded-full bg-white">
                <Icon iconKey="done" className="text-main size-6" />
            </div>
            <div className="flex flex-col justify-center p-6">
                <div className="text-sm/4 font-bold">{header}</div>
                <div className="mt-1 text-xs">{text}</div>
            </div>
        </div>
    );
};

export default FlowAlert;
